module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Compass-91c431457dad9c7231bb74fdc05980dd.svg";